export type Locale = "fi" | "en" | "sv";
export const DefaultLocale: Locale = "fi";

// all system wide (use only in a few places)
export const AllLocales: Locale[] = ["fi", "en", "sv"];

// define a new type to handle locale strings
export type LocaleString = Record<Locale, string>;
